module.exports = __webpack_public_path__ + "img/look16.5a29f8bf.png";